<template>
  <div>
    <app-head></app-head>
    <app-body>
      <div>
        <div class="news-background">
        </div>
        <div class="news-container">
          <!-- 文章头部 -->
          <header class="article-header">
            <h1 class="article-title">{{ article.title }}</h1>
            <div class="article-meta">
              <div class="meta-item">
                <i class="el-icon-time"></i>
                <span>发表时间：{{ formatDateTime(article.publishTime) }}</span>
              </div>
              <div class="meta-item">
                <i class="el-icon-view"></i>
                <span>阅读量：{{ article.readCount }}</span>
              </div>
            </div>
          </header>

          <!-- 文章内容 -->
          <article class="article-content">
            <div class="content-text">
              <mavon-editor
                  v-model="article.content"
                  :editable="false"
                  :subfield="false"
                  :toolbarsFlag="false"
                  defaultOpen="preview"
              />
            </div>
          </article>

          <!-- 文章底部 -->
          <footer class="article-footer">
            <div class="footer-top">
              <div class="tags">
                <span>标签：</span>
                <el-tag v-for="tag in article.tagList" :key="tag" type="info">{{ tag }}</el-tag>
              </div>
              <div class="actions">
                <el-button type="text" @click="copyUrl()">
                  <i class="el-icon-share"></i>
                  <span>分享</span>
                </el-button>
              </div>
            </div>
            <br>
            <div class="footer-bottom">
              <div class="prev-next">
                <div class="prev">
                  <span>上一篇：</span>
                  <a v-if="article.prevNews" :href="`/newsDetails?id=${article.prevNews.id}`">{{ article.prevNews.title }}</a>
                  <span v-else>没有上一篇</span>
                </div>
                <div class="next">
                  <span>下一篇：</span>
                  <a v-if="article.nextNews" :href="`/newsDetails?id=${article.nextNews.id}`">{{ article.nextNews.title }}</a>
                  <span v-else>没有下一篇</span>
                </div>
              </div>
<!--              <div>
                <el-button type="text" @click="$router.go(-1)">
                  <span>返回</span>
                </el-button>
                <br>
                <el-button type="text" @click="$router.go(-1)">
                  <span>返回至'新闻资讯'</span>
                </el-button>
              </div>-->
            </div>
          </footer>
        </div>
      </div>
    </app-body>
    <app-foot></app-foot>
  </div>
</template>

<script>
import AppHead from '../common/AppHeader.vue';
import AppBody from '../common/AppPageBody.vue'
import AppFoot from '../common/AppFoot.vue'

export default {
  name: "index",
  components: {
    AppHead,
    AppBody,
    AppFoot
  },
  data() {
    return {
      form: {
        content: ''
      },
      article: {
        title: '无数据',
        publishTime: new Date(),
        views: 0,
        content: '无数据',
        tags: ['固态硬盘', '存储技术', '硬件'],
        prevNews: {
        },
        nextNews: {
        }
      }
    };
  },
  created() {
    let id = this.$route.query.id;
    this.getDetails(id);
  },
  methods: {
    getDetails(id) {
      this.$api.getNewsDetails({
        id: id
      }).then(res => {
        if (res.code === 200) {
          this.article = res.data;
        }
      })
    },
    //================== 该方法不支持HTTP ==================
    copyUrl() {
      const url = window.location.href;
      if (navigator.clipboard && window.isSecureContext) {
        this.useModernClipboardAPI(url);// 使用现代API复制文本(HTTPS)
        return;
      }
      this.useLegacyCopyMethod(url);// 使用传统方法复制文本(HTTP)
    },
    useModernClipboardAPI(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$message.success('已复制当前链接');
      }).catch((error) => {
        this.useLegacyCopyMethod(text);
      });
    },
    useLegacyCopyMethod(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      Object.assign(textarea.style, {
        position: 'absolute',
        left: '-9999px'
      });
      document.body.appendChild(textarea);
      textarea.select();
      try {
        if (document.execCommand('copy')) {
          this.$message.success('已复制当前链接');
        } else {
          throw new Error('execCommand返回false');
        }
      } catch (err) {
        this.$message.error('复制失败，请手动复制链接');
      } finally {
        document.body.removeChild(textarea);
      }
    },
    formatDateTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  }
}
</script>

<style scoped>

.news-background {
  width: 100%;
  background-image: url("../../../assets/img/article-bg.jpg");
  margin-top: -30px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 500px;
}

.news-container {
  width: 100%;
  max-width: 1200px;
  margin: 100px auto;
  padding: 0 20px;
}


.article-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.article-header {
  margin-bottom: 30px;
}

.article-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
}

.article-meta {
  display: flex;
  align-items: center;
  color: #909399;
  font-size: 14px;
}

.meta-item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.meta-item i {
  margin-right: 5px;
}

.article-content {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin-bottom: 30px;
}

.content-text {
  color: #606266;
  line-height: 1.75;
  position: relative;
  z-index: 1;
}

.content-text p {
  margin-bottom: 20px;
}

.content-box {
  background-color: #f5f7fa;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.content-box h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
}

.content-box ul {
  list-style: none;
  padding-left: 0;
}

.content-box li {
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
}

.content-box i {
  color: #409eff;
  margin-right: 10px;
  margin-top: 3px;
}

.article-footer {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 30px;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.tags {
  display: flex;
  align-items: center;
  color: #909399;
}

.tags .el-tag {
  margin-left: 10px;
}

.recommendations h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #303133;
}

.el-card {
  margin-bottom: 20px;
}

.el-card h4 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #303133;
}

.el-card p {
  font-size: 14px;
  color: #909399;
}

.prev-next a {
  color: inherit; /* 继承父元素颜色，避免默认蓝色 */
  text-decoration: none; /* 移除下划线 */
}

.prev-next a:hover {
  text-decoration: underline; /* 鼠标悬停时显示下划线，增强交互 */
}
</style>